/*
 * Lanificio, Black Friday 2026 (ontwerp v8): <rug-unroll src="..." alt="...">.
 * Hoort bij sections/lan-black-friday-uitrollen.liquid.
 *
 * Een kleed (uitgesneden foto, transparante achtergrond) rolt zich in 3D uit,
 * gekoppeld aan de scrollpositie van de dichtstbijzijnde [data-scene]-sectie
 * (420vh hoog, binnenin een sticky vlak van 100svh). three.js 0.160 komt van
 * unpkg en wordt pas geladen als de sectie in de buurt komt.
 * Zonder WebGL, als laden mislukt of met minder beweging: een gewone <img>.
 */
(function () {
  if (!window.customElements || customElements.get('rug-unroll')) return;
  var THREE_URL = 'https://unpkg.com/three@0.160.0/build/three.module.min.js';
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var ss = function (t) { return t * t * (3 - 2 * t); };
  var eio = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
  var lerp = function (a, b, t) { return a + (b - a) * t; };
  var path = function (keys, p) {
    for (var i = 0; i < keys.length - 1; i++) {
      var pa = keys[i][0], A = keys[i][1], pb = keys[i + 1][0], B = keys[i + 1][1];
      if (p <= pb || i === keys.length - 2) {
        var t = ss(clamp((p - pa) / (pb - pa), 0, 1));
        return A.map(function (v, k) { return lerp(v, B[k], t); });
      }
    }
  };
  var reduced = function () {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  };

  class RugUnroll extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      Object.assign(this.style, { display: 'block', position: 'absolute', inset: '0' });
      if (reduced() || !('IntersectionObserver' in window)) { this.fallback(); return; }
      var self = this;
      this.io = new IntersectionObserver(function (entries) {
        if (!entries.some(function (e) { return e.isIntersecting; })) return;
        self.io.disconnect();
        self.init().catch(function () { self.fallback(); });
      }, { rootMargin: '150% 0px 150% 0px' });
      this.io.observe(this.closest('[data-scene]') || this);
    }
    disconnectedCallback() {
      this.dead = true;
      cancelAnimationFrame(this.raf);
      if (this.io) this.io.disconnect();
      if (this.ro) this.ro.disconnect();
      if (this.renderer) this.renderer.dispose();
    }
    fallback() {
      if (this.renderer && this.renderer.domElement.parentNode) this.renderer.domElement.remove();
      if (this.querySelector('img')) return;
      var i = document.createElement('img');
      i.src = this.getAttribute('src');
      i.alt = this.getAttribute('alt') || '';
      i.loading = 'lazy';
      i.className = 'lbf-rol__plat';
      this.appendChild(i);
    }
    async init() {
      const THREE = await import(THREE_URL);
      if (this.dead) return;
      const tex = await new Promise((res, rej) => { const l = new THREE.TextureLoader(); l.setCrossOrigin('anonymous'); l.load(this.getAttribute('src'), res, undefined, rej); });
      if (this.dead) return;
      tex.colorSpace = THREE.SRGBColorSpace;
      const W = 2.2, L = W * (tex.image.height / tex.image.width);
      const mobile = Math.min(window.innerWidth, window.innerHeight) < 700;
      const renderer = this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, powerPreference: 'high-performance' });
      tex.anisotropy = renderer.capabilities.getMaxAnisotropy();
      renderer.setPixelRatio(Math.min(mobile ? 1.6 : 2, window.devicePixelRatio || 1));
      renderer.shadowMap.enabled = true; renderer.shadowMap.type = THREE.PCFSoftShadowMap;
      renderer.outputColorSpace = THREE.SRGBColorSpace; renderer.toneMapping = THREE.ACESFilmicToneMapping; renderer.toneMappingExposure = 1.15;
      Object.assign(renderer.domElement.style, { width: '100%', height: '100%', display: 'block' });
      renderer.domElement.setAttribute('role', 'img'); renderer.domElement.setAttribute('aria-label', this.getAttribute('alt') || '');
      this.appendChild(renderer.domElement);
      const scene = new THREE.Scene();
      const cam = new THREE.PerspectiveCamera(34, 1, 0.03, 100);
      scene.add(new THREE.HemisphereLight(0xfafaf8, 0x161514, 0.55));
      const key = new THREE.SpotLight(0xfff0dc, 90, 0, 0.55, 0.6, 1.7);
      key.castShadow = true; key.shadow.mapSize.set(mobile ? 1024 : 2048, mobile ? 1024 : 2048); key.shadow.bias = -0.0004; key.shadow.radius = 6;
      scene.add(key, key.target);
      const rim = new THREE.DirectionalLight(0xd8deff, 0.9); rim.position.set(3, 2.2, -5); scene.add(rim);
      const floor = new THREE.Mesh(new THREE.PlaneGeometry(40, 40), new THREE.ShadowMaterial({ opacity: 0.6 }));
      floor.rotation.x = -Math.PI / 2; floor.receiveShadow = true; scene.add(floor);
      const NX = 14, NZ = mobile ? 380 : 560, n = (NX + 1) * (NZ + 1);
      const pos = new Float32Array(n * 3), uv = new Float32Array(n * 2), idx = [];
      for (let j = 0; j <= NZ; j++) for (let i = 0; i <= NX; i++) { const k = j * (NX + 1) + i; uv[k * 2] = i / NX; uv[k * 2 + 1] = 1 - j / NZ; }
      for (let j = 0; j < NZ; j++) for (let i = 0; i < NX; i++) { const a = j * (NX + 1) + i, b = a + 1, c = a + NX + 1, d = c + 1; idx.push(a, c, b, b, c, d); }
      const geo = new THREE.BufferGeometry();
      geo.setAttribute('position', new THREE.BufferAttribute(pos, 3)); geo.setAttribute('uv', new THREE.BufferAttribute(uv, 2)); geo.setIndex(idx);
      const ac = document.createElement('canvas'); ac.width = tex.image.width; ac.height = tex.image.height;
      const actx = ac.getContext('2d'); actx.drawImage(tex.image, 0, 0); const ad = actx.getImageData(0, 0, ac.width, ac.height);
      for (let i = 0; i < ad.data.length; i += 4) { const v = ad.data[i + 3]; ad.data[i] = ad.data[i + 1] = ad.data[i + 2] = v; ad.data[i + 3] = 255; }
      actx.putImageData(ad, 0, 0); const alpha = new THREE.CanvasTexture(ac);
      const wc = document.createElement('canvas'); wc.width = wc.height = 128; const wx = wc.getContext('2d');
      wx.fillStyle = '#3d3934'; wx.fillRect(0, 0, 128, 128);
      for (let y = 0; y < 128; y += 4) for (let x = 0; x < 128; x += 4) { const o = ((x + y) / 4) % 2; const v = 52 + Math.random() * 18; wx.fillStyle = 'rgb(' + (v + 6) + ',' + (v + 2) + ',' + v + ')'; wx.fillRect(x, y + (o ? 0 : 1), o ? 4 : 3, o ? 3 : 4); }
      const weave = new THREE.CanvasTexture(wc); weave.wrapS = weave.wrapT = THREE.RepeatWrapping; weave.repeat.set(22, 22 * L / W); weave.colorSpace = THREE.SRGBColorSpace;
      const geoF = new THREE.BufferGeometry(); const posF = new Float32Array(n * 3);
      geoF.setAttribute('position', new THREE.BufferAttribute(posF, 3)); geoF.setAttribute('normal', new THREE.BufferAttribute(new Float32Array(n * 3), 3)); geoF.setAttribute('uv', geo.attributes.uv); geoF.setIndex(idx);
      const front = new THREE.Mesh(geoF, new THREE.MeshStandardMaterial({ map: tex, bumpMap: tex, bumpScale: 4, roughness: 0.94, metalness: 0, side: THREE.FrontSide, alphaTest: 0.5, transparent: false }));
      const back = new THREE.Mesh(geo, new THREE.MeshStandardMaterial({ map: weave, bumpMap: weave, bumpScale: 2, roughness: 1, side: THREE.DoubleSide, alphaMap: alpha, alphaTest: 0.5, transparent: false }));
      const depth = new THREE.MeshDepthMaterial({ depthPacking: THREE.RGBADepthPacking, map: tex, alphaTest: 0.5, side: THREE.DoubleSide });
      front.customDepthMaterial = back.customDepthMaterial = depth;
      const midMat = new THREE.MeshStandardMaterial({ map: tex, color: 0x9a9a9a, roughness: 1, side: THREE.DoubleSide, alphaTest: 0.5 });
      const mids = [];
      for (let m = 1; m <= 5; m++) {
        const g = new THREE.BufferGeometry(); const pa = new Float32Array(n * 3);
        g.setAttribute('position', new THREE.BufferAttribute(pa, 3)); g.setAttribute('normal', new THREE.BufferAttribute(new Float32Array(n * 3), 3)); g.setAttribute('uv', geo.attributes.uv); g.setIndex(idx);
        const mesh = new THREE.Mesh(g, midMat); mesh.castShadow = true; mesh.customDepthMaterial = depth; scene.add(mesh); mids.push({ g, pa, f: m / 6 });
      }
      front.castShadow = back.castShadow = true; front.receiveShadow = back.receiveShadow = true;
      scene.add(front, back);
      const dn = mobile ? 220 : 480, dp = new Float32Array(dn * 3), seed = new Float32Array(dn);
      for (let i = 0; i < dn; i++) { dp[i * 3] = (Math.random() - 0.5) * 4; dp[i * 3 + 1] = Math.random() * 2.6; dp[i * 3 + 2] = (Math.random() - 0.5) * 4; seed[i] = Math.random() * 6.28; }
      const dgeo = new THREE.BufferGeometry(); dgeo.setAttribute('position', new THREE.BufferAttribute(dp, 3));
      const dust = new THREE.Points(dgeo, new THREE.PointsMaterial({ color: 0xfff3e2, size: 0.012, transparent: true, opacity: 0.55, depthWrite: false, blending: THREE.AdditiveBlending }));
      scene.add(dust);
      const T = 0.085, kk = T / Math.PI, r0 = 0.12, z0 = -L / 2, OFF = 0.07;
      const shape = (u, f, time) => {
        const R = Math.sqrt(r0 * r0 + kk * (L - u));
        const lift = 0.22 * f, tilt = 0.16 * f;
        for (let j = 0; j <= NZ; j++) {
          const s = (j / NZ) * L; let y, z;
          if (s <= u) { y = 0.004; z = z0 + s; }
          else { const t = s - u; const r = Math.sqrt(Math.max(r0 * r0, R * R - kk * t)); const ph = (2 / kk) * (R - r); z = z0 + u + r * Math.sin(ph); y = R - r * Math.cos(ph) + 0.006; }
          const zn = (z - z0) / L;
          for (let i = 0; i <= NX; i++) {
            const k = (j * (NX + 1) + i) * 3, xn = i / NX - 0.5;
            let yy = y;
            if (f > 0) yy += lift + (0.5 - zn) * tilt + f * (0.045 * Math.sin(zn * 7.5 - time * 0.0017) + 0.025 * Math.sin(xn * 5 + zn * 3 - time * 0.0011));
            pos[k] = xn * W; pos[k + 1] = yy; pos[k + 2] = z;
          }
        }
        geo.attributes.position.needsUpdate = true; geo.computeVertexNormals(); geo.computeBoundingSphere();
        const nr = geo.attributes.normal.array, nf = geoF.attributes.normal.array;
        for (let q = 0; q < pos.length; q++) { posF[q] = pos[q] + nr[q] * OFF; nf[q] = nr[q]; }
        geoF.attributes.position.needsUpdate = true; geoF.attributes.normal.needsUpdate = true; geoF.computeBoundingSphere();
        for (const L2 of mids) { const o = OFF * L2.f, na = L2.g.attributes.normal.array; for (let q = 0; q < pos.length; q++) { L2.pa[q] = pos[q] + nr[q] * o; na[q] = nr[q]; } L2.g.attributes.position.needsUpdate = true; L2.g.attributes.normal.needsUpdate = true; L2.g.computeBoundingSphere(); }
      };
      let fitD = 6, portrait = false;
      const resize = () => {
        const w = this.clientWidth || 1, h = this.clientHeight || 1; renderer.setSize(w, h, false);
        cam.aspect = w / h; portrait = cam.aspect < 0.95;
        const tf = Math.tan((cam.fov * Math.PI / 180) / 2);
        fitD = Math.max((L * 1.12) / (2 * tf), (W * 1.3) / (2 * tf * cam.aspect));
        cam.clearViewOffset();
        if (portrait) cam.setViewOffset(w, h, 0, -h * 0.1, w, h); else cam.setViewOffset(w, h, -w * (cam.aspect > 1.6 ? 0.14 : 0.18), -h * 0.06, w, h);
        cam.updateProjectionMatrix();
      };
      this.ro = new ResizeObserver(resize); this.ro.observe(this); resize();
      const host = this.closest('[data-scene]');
      const look = new THREE.Vector3();
      const loop = time => {
        if (this.dead) return; this.raf = requestAnimationFrame(loop);
        const r = (host || this).getBoundingClientRect(), vh = window.innerHeight;
        if (r.bottom < 0 || r.top > vh) return;
        const p = clamp(-r.top / Math.max(1, r.height - vh), 0, 1);
        const u = L * (0.14 + 0.86 * eio(clamp((p - 0.08) / 0.57, 0, 1)));
        const f = ss(clamp((p - 0.7) / 0.22, 0, 1));
        shape(u, f, time);
        const s = portrait ? 1.25 : 1, D = fitD;
        const K = [
          [0.0, [W / 2 + 1.9 * s, 1.15 * s, z0 + 2.6 * s, 0.1, 0.12, z0 + 0.5]],
          [0.16, [W / 2 + 1.6 * s, 1.5 * s, z0 + 3.2 * s, 0, 0.1, z0 + 0.9]],
          [0.45, [1.9 * s, D * 0.42, D * 0.62, 0, 0.05, 0.1]],
          [0.72, [0.12, D * 0.98, D * 0.2, 0, 0, 0.02]],
          [1.0, [-1.1 * s, D * 0.68, D * 0.62, 0, 0.18, 0]]
        ];
        const c = path(K, p), br = Math.sin(time / 2800) * 0.03;
        cam.position.set(c[0] + br, c[1] + br * 0.5, c[2]); look.set(c[3], c[4], c[5]); cam.lookAt(look);
        key.position.set(lerp(-3.2, 2.4, p), 6.2, lerp(1.2, 2.6, p)); key.target.position.set(0, 0, lerp(z0 + 0.4, 0, p));
        for (let i = 0; i < dn; i++) { dp[i * 3 + 1] = (dp[i * 3 + 1] + 0.0009 + Math.sin(time * 0.0006 + seed[i]) * 0.0006) % 2.6; dp[i * 3] += Math.sin(time * 0.0004 + seed[i]) * 0.0006; }
        dgeo.attributes.position.needsUpdate = true;
        renderer.render(scene, cam);
      };
      this.raf = requestAnimationFrame(loop);
    }
  }
  customElements.define('rug-unroll', RugUnroll);
})();
